import React from 'react';
import { string } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const RouteDetails = ({ distance, elevation, color }) => {
  return (
    <div className={styles.container}>
      {color ? (
        <div className={styles.routeColor} style={{ backgroundColor: color }} />
      ) : (
        <div className={styles.total}>{StringConstantsMixin.strings.TOTAL}</div>
      )}
      <div className={styles.statInfo}>
        <div className={styles.statTitle}>{StringConstantsMixin.strings.STATS.NORMAL.DISTANCE}</div>
        <div className={styles.stat}>{distance}</div>
      </div>
      <div className={styles.statInfo}>
        <div className={styles.statTitle}>{StringConstantsMixin.strings.STATS.NORMAL.ELEVATION_GAIN}</div>
        <div className={styles.stat}>{elevation}</div>
      </div>
    </div>
  );
};

RouteDetails.propTypes = {
  distance: string.isRequired,
  elevation: string.isRequired,
  color: string
};

RouteDetails.defaultProps = {
  color: null
};

export default RouteDetails;
